import StorageHelper from '@/utils/storageHelper';

const clientSessionStorage = new StorageHelper({
  id: process.env.VUE_APP_STORAGE_PMAKTIF_CLIENT_SESSION_ID,
});

export function getOrCreateClientSessionId() {
  let clientSessionId = clientSessionStorage.get();

  if (!clientSessionId) {
    clientSessionId = crypto.randomUUID();
    clientSessionStorage.set(clientSessionId);
  }
  return clientSessionId;
}
